import getWithToken from './base/get-with-token'

const getSignedUrlAzure = (data) => getWithToken(`/devices/download-file`)(data)

export default getSignedUrlAzure